import { Component } from '@angular/core';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.css'],
    standalone: false
})
export class AdminComponent {
  selectedTab = 0;

  // Tab groups for organization
  notificationTabs = [
    { title: 'Email Templates', icon: 'email' },
    { title: 'Distribution Lists', icon: 'users' },
    { title: 'Notification Log', icon: 'list-unordered' }
  ];

  routerTabs = [
    { title: 'Router Templates', icon: 'track-changes-enable' },
    { title: 'Feature Mappings', icon: 'link-horizontal' }
  ];

  onTabSelect(e: any): void {
    this.selectedTab = e.index;
  }
}
